import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { MAX_LICENSES, MIN_LICENSES } from './types';

const clampLicenses = (value: number) =>
  Math.min(MAX_LICENSES, Math.max(MIN_LICENSES, value));

const parseLicenses = (raw: string): number | null => {
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return null;
  return Math.trunc(parsed);
};

interface LicenseCounterProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const LicenseCounter = ({ value, onChange, disabled }: LicenseCounterProps) => {
  const handleTyped = (raw: string) => {
    if (raw.trim() === '') {
      onChange(MIN_LICENSES);
      return;
    }
    const parsed = parseLicenses(raw);
    if (parsed === null) return;
    onChange(clampLicenses(parsed));
  };

  return (
    <Tooltip title="Number of licenses" placement="top" arrow>
      <Box display="flex" alignItems="center" style={{ gap: 4 }}>
      <IconButton
        size="small"
        disabled={disabled || value <= MIN_LICENSES}
        onClick={() => onChange(clampLicenses(value - 1))}
        style={{
          border: '1px solid #E5E7EB',
          borderRadius: 6,
          width: 32,
          height: 32,
        }}>
        <RemoveIcon fontSize="small" />
      </IconButton>
      <TextField
        size="small"
        type="number"
        value={value}
        disabled={disabled}
        onChange={(event) => handleTyped(event.target.value)}
        inputProps={{
          min: MIN_LICENSES,
          max: MAX_LICENSES,
          style: { textAlign: 'center', padding: '8px 4px' },
        }}
        sx={{
          width: 72,
          '& .MuiOutlinedInput-root': { height: 36, fontSize: 13 },
          '& input[type=number]': {
            MozAppearance: 'textfield',
          },
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
            {
              WebkitAppearance: 'none',
              margin: 0,
            },
        }}
      />
      <IconButton
        size="small"
        disabled={disabled || value >= MAX_LICENSES}
        onClick={() => onChange(clampLicenses(value + 1))}
        style={{
          border: '1px solid #E5E7EB',
          borderRadius: 6,
          width: 32,
          height: 32,
        }}>
        <AddIcon fontSize="small" />
      </IconButton>
      </Box>
    </Tooltip>
  );
};
